<template>
  <div class="tabs">
    <input id="applied" type="radio" name="tab_item" checked />
    <label class="applied tab_item" for="applied" @click="tabChange(1)"
      ><span
        class="new"
        :style="[applied > 9 ? 'width: 20px;' : 'width: 16px;']"
        v-show="applied > 0 && tabName1"
        >{{ applied }}</span
      >{{ tabName1 }}
    </label>
    <input id="in-progress" type="radio" name="tab_item" />

    <label class="in-progress tab_item" for="in-progress" @click="tabChange(2)"
      ><span
        class="new"
        :style="[progress > 9 ? 'width: 20px;' : 'width: 16px;']"
        v-show="progress > 0 && tabName2"
        >{{ progress }}</span
      >{{ tabName2 }}</label
    >
    <input id="deliverd" type="radio" name="tab_item" />
    <label class="deliverd tab_item" for="deliverd" @click="tabChange(3)"
      ><span
        class="new"
        :style="[completed > 9 ? 'width: 20px;' : 'width: 16px;']"
        v-show="completed > 0 && tabName3"
        >{{ completed }}</span
      >{{ tabName3 }}</label
    >
    <span id="slider"></span>
  </div>
</template>

<script setup lang="ts">
import { ProjectStore } from "../store/ProjectStore";
import { nextTick, onMounted } from "vue";

const omistore = ProjectStore();
export type TabsProps = {
  tabName1: string;
  tabName2: string;
  tabName3: string;
  applied: number;
  progress: number;
  completed: number;
};

const emit = defineEmits(["tabchange"]);

onMounted(async () => {
  tabChange(omistore.selectedStatus);
  await nextTick()
  const elements = document.getElementsByName(
    "tab_item"
  ) as NodeListOf<HTMLInputElement>;
  elements[omistore.selectedStatus - 1].checked = true;
});

defineProps<TabsProps>();
// APIを公開
defineExpose({
  tabChange,
});

function tabChange(tabId: number) {
  emit("tabchange", tabId);
}
</script>
<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";
.tabs {
  z-index: 9999;
  @include header();
  position: relative;
  .new {
    position: absolute;
    display: flex;
    color: #ffffff;
    font-weight: bold;
    line-height: 20px;
    text-align: center;
    justify-content: center;
    align-items: center;
    background: rgba(249, 208, 20, 1);
    border-radius: 8px;
    font-size: $FONT_SIZE_S;
    // width: 16px;
    height: 16px;
    left: 10px;
    top: -5px;
    box-sizing: border-box;
  }
}
.tabs input:checked + .tab_item {
  color: $OMOT_COLOR;
  border-bottom: $OMOT_COLOR;
  opacity: 0.75;
  transition: width 0.3s ease;
}
input[name="tab_item"] {
  display: none;
  border-radius: 90px;
  color: $white;
  height: 40px;
}
.tab-item {
  border-bottom: 2px solid #ddd;
  position: relative;
  height: 40px;
}

.tabs {
  height: 40px;
  background-color: $white;
  border-bottom: 1px solid $grey;
}
.applied {
  @include tabs();
  left: 0;
  top: 9px;
}
.in-progress {
  @include tabs();
  left: 33%;
  top: 9px;
}
.deliverd {
  @include tabs();
  right: 0;
  top: 9px;
}
input {
  display: none;
  border-radius: 90px;
  color: $white;
}
#slider {
  z-index: 1;
  position: absolute;
  left: 0%;
  top: 0;
  // width: 125px;
  width: 100px;
  height: 40px;
  margin: 0 0 0 0;
  border-bottom: solid $OMOT_COLOR;
  transition: transform 1s;
  animation-timing-function: ease-in-out;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  transition: 0.3s left ease-in-out;
}
#applied:checked ~ #slider {
  animation-name: applied;
  left: 13px;
}
#in-progress:checked ~ #slider {
  animation-name: in-progress;
  left: calc(33% + 13px);
}
#deliverd:checked ~ #slider {
  animation-name: deliverd;
  left: calc(65% + 18px);
}
</style>
